import React from 'react'
import { Input, Space } from 'antd'
import styles from './official-whatsapp.module.scss'

const InputTemplate = ({ backgroundColor, defaultValue, value, onChange }) => {
  if (defaultValue.includes('\n\n')) {
    return (
      <div className={`mb-3 ${styles.textArea}`} style={{ '--background-color': backgroundColor }}>
        <div className={styles.sideAccent} />
        <Input.TextArea
          autoSize={{ minRows: 2, maxRows: 8 }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    )
  }

  return (
    <Space.Compact
      className={`${styles.input} w-100 mb-3`}
      style={{ '--background-color': backgroundColor }}
    >
      <div />
      <Input value={value} onChange={(e) => onChange(e.target.value)} />
    </Space.Compact>
  )
}

export default InputTemplate
